import { Vector3 } from 'three'
import { useWallSegmentSnapLines } from '~/components/DrawingCanvas/hooks'
import { snapToLineOrIntersection } from '~/components/DrawingCanvas/util/snaplines'

export function useSnap(x: number, y: number) {
  const snaplines = useWallSegmentSnapLines()

  const result = new Vector3(x, y, 0)
  const snapPoint = snapToLineOrIntersection(snaplines, result, false)
  if (snapPoint) {
    return [snapPoint, snapPoint.snapPoint] as const
  }
  return [undefined, result] as const
}
